module.exports = __webpack_public_path__ + "img/rose.be5030ca.webp";